module.exports = __webpack_public_path__ + "img/buy0145.ad5373f1.svg";